import { Table } from 'components/common';
import styled from 'styled-components';

export const ConstrainedTable = styled(Table)`
  max-height: 60vh;
  overflow-y: auto;
`;
